import { Col, Row } from "antd";
import ChangeLogs from "./component/change-logs";
import Demo from "./component/demo";
import Features from "./component/features";
import Installation from "./component/installation";
import Introduce from "./component/introduce";

export default function HomePage() {
  return (
    <Row className="home-page">
      <Col xs={24} className="section">
        <div className="page-container">
          <Introduce />
          <div style={{ marginTop: 64 }}>
            <ChangeLogs />
          </div>
        </div>
      </Col>
      <Col xs={24} className="section-grey">
        <div className="page-container">
          <Demo />
        </div>
      </Col>
      <Col xs={24} className="section">
        <div className="page-container">
          <Installation />
        </div>
      </Col>
      <Col xs={24} className="section-grey">
        <div className="page-container">
          <Features />
        </div>
      </Col>
    </Row>
  );
}
